// extracted by mini-css-extract-plugin
export default {"container":"TextArea_container__y7ri0","textareaContainer":"TextArea_textareaContainer__oW2Ws","charactercount":"TextArea_charactercount__wTXHm"};